export default function getIsCurrentGroupSystem(state: any) {
  return state.getIn(['currentGroup', 'data', 'type']) === 5;
}
